const FlexBoxClasses = {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    pt: 8,
    width: 366,
};

export {FlexBoxClasses};
